// Module
var code = "<div class=\"master col s4 p-8x\"> </div> <div class=\"detail col s8 p-8px\"> </div> ";
// Exports
export default code;